import { render, staticRenderFns } from "./meus_pets.vue?vue&type=template&id=1370ef13&scoped=true&"
import script from "./meus_pets.vue?vue&type=script&lang=js&"
export * from "./meus_pets.vue?vue&type=script&lang=js&"
import style0 from "./meus_pets.vue?vue&type=style&index=0&id=1370ef13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370ef13",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VDialog,VIcon,VRow})
